var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    display: "block",
    className: "vkuiIcon vkuiIcon--24 vkuiIcon--w-24 vkuiIcon--h-24 vkuiIcon--add_circle_outline_24",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      width: 24,
      height: 24
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "add_circle_outline_24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 7a.9.9 0 0 1 .9.9v3.2h3.2a.9.9 0 0 1 .9.9.9.9 0 0 1-.9.9h-3.2v3.2a.9.9 0 0 1-.9.9.9.9 0 0 1-.9-.9v-3.2H7.9A.9.9 0 0 1 7 12a.9.9 0 0 1 .9-.9h3.2V7.9A.9.9 0 0 1 12 7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.9a8.1 8.1 0 1 0 0 16.2 8.1 8.1 0 0 0 0-16.2M2.1 12c0-5.468 4.432-9.9 9.9-9.9s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9-9.9-4.432-9.9-9.9",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#add_circle_outline_24",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.68d102af5bc38cca67f98a8eaedb87d9.svg";
export { ForwardRef as ReactComponent };